import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { Config } from "../../../../utils/config"
import { TimeSpan } from "@figurepos/fgr-lib-business-logic/lib/common/dateTime/hours_of_operation_v2"

export const getDefaultPickupSettings = () => ({
    MIB_ESTIMATED_PICKUP_TIME: null,
    MIB_MIN_PICKUP_VALUE: null,
    MIB_LAST_PICKUP_TIME: null,
    MIB_IS_FUTURE_ORDER_PICKUP_VALUE: null,
    MIB_PICKUP_CURBSIDE_OPTION_ENABLED: null,
    MIB_PICKUP_CURBSIDE_OPTION_GUIDANCE: null,
})

export const appendHostnameToImageUrl = (val: Maybe<string>): Maybe<string> => {
    if (!val) {
        return null
    }
    if (val.includes("http")) {
        return val
    }
    if (Config.environment === "production") {
        return `https://www.makeitbutter.com${val}`
    }
    if (Config.environment === "development") {
        return `https://dev.makeitbutter.com${val}`
    }
    return null
}

export const areAllTimeSpansInactive = (timeSpans: Maybe<TimeSpan[]>): boolean => {
    if (!timeSpans) {
        return true
    }
    return timeSpans.every(ts => ts.includes("x"))
}
